import { Form } from "react-bootstrap";

export default function OntarioLocateReportAuxiliaryPageFields({ auxiliaryPage, onChange }) {
    const idPrefix = `olr-aux-${auxiliaryPage.limitIndex}-${auxiliaryPage.workflowId}`;

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>Utilities Located</Form.Label>
                <Form.Control size='sm' type='text' value={auxiliaryPage.utilitiesLocated ?? ''} onChange={e => onChange({ ...auxiliaryPage, utilitiesLocated: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>Number of Services Marked</Form.Label>
                <Form.Control size='sm' type='number' value={auxiliaryPage.numberOfServicesMarked ?? ''} onChange={e => onChange({ ...auxiliaryPage, numberOfServicesMarked: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>North Boundary</Form.Label>
                <Form.Control size='sm' type='text' value={auxiliaryPage.northBoundary ?? ''} onChange={e => onChange({ ...auxiliaryPage, northBoundary: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>East Boundary</Form.Label>
                <Form.Control size='sm' type='text' value={auxiliaryPage.eastBoundary ?? ''} onChange={e => onChange({ ...auxiliaryPage, eastBoundary: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>South Boundary</Form.Label>
                <Form.Control size='sm' type='text' value={auxiliaryPage.southBoundary ?? ''} onChange={e => onChange({ ...auxiliaryPage, southBoundary: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>West Boundary</Form.Label>
                <Form.Control size='sm' type='text' value={auxiliaryPage.westBoundary ?? ''} onChange={e => onChange({ ...auxiliaryPage, westBoundary: e.target.value })} />
            </Form.Group>
            <div className='d-flex align-items-center mb-3'>
                <Form.Check type='switch' id={`${idPrefix}-altered`} checked={auxiliaryPage.locateAreaHasBeenAltered ?? false} onChange={e => onChange({ ...auxiliaryPage, locateAreaHasBeenAltered: e.target.checked })} className="me-2" />
                <p className="mb-0 fs-sm">Locate area has been altered</p>
            </div>
            <Form.Group className="mb-3">
                <Form.Label className='text-body fs-sm fw-semibold'>Locator Remarks</Form.Label>
                <Form.Control size='sm' as='textarea' rows='3' value={auxiliaryPage.locatorRemarks ?? ''} onChange={e => onChange({ ...auxiliaryPage, locatorRemarks: e.target.value })} />
            </Form.Group>
        </>
    );
}
